// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// Importing namespace specific controllers

import AccountRegistrationController from "./account_registration_controller"
application.register("account-registration", AccountRegistrationController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CartDrawerController from "./cart_drawer_controller"
application.register("cart-drawer", CartDrawerController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import ProductTwisterController from "./product_twister_controller"
application.register("product-twister", ProductTwisterController)

// Importing shared controllers

import AddressConfirmationController from "../shared/address_confirmation_controller"
application.register("address-confirmation", AddressConfirmationController)

import AlertController from "../shared/alert_controller"
application.register("alert", AlertController)

import CheckAllController from "../shared/check_all_controller"
application.register("check-all", CheckAllController)

import CreditCardController from "../shared/credit_card_controller"
application.register("credit-card", CreditCardController)

import FormController from "../shared/form_controller"
application.register("form", FormController)

import ModalController from "../shared/modal_controller"
application.register("modal", ModalController)

import ModalDismissController from "../shared/modal_dismiss_controller"
application.register("modal-dismiss", ModalDismissController)

import NumberIncrementerController from "../shared/number_incrementer_controller"
application.register("number-incrementer", NumberIncrementerController)

import PopoverController from "../shared/popover_controller"
application.register("popover", PopoverController)

import TimeagoController from "../shared/timeago_controller"
application.register("timeago", TimeagoController)

import TooltipController from "../shared/tooltip_controller"
application.register("tooltip", TooltipController)

import TurboRefreshController from "../shared/turbo_refresh_controller"
application.register("turbo-refresh", TurboRefreshController)

import UncoverableController from "../shared/uncoverable_controller"
application.register("uncoverable", UncoverableController)
